import React from 'react';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Box,
  Flex,
  ModalFooter,
  Divider,
} from '@chakra-ui/react';

import { Cross, Repeat } from 'assets/assetsV1/iconComponents';

import { isMobileView } from 'constants/isMobileView';

import { Button } from 'uiToolkitV1/Button';
import { Radio } from 'uiToolkitV1/Radio';
import { TextBodyMedium, TextHeader3 } from 'uiToolkitV1/Typography';

import { StyleCloseButton } from './ArchiveMeetingModal';

interface Props {
  isOpen?: boolean;
  onClose?: () => void;
  onSave?: (any) => void;
  onRadioChange?: (isEditSingleMeeting: boolean) => void;
  isEditSingleMeeting?: boolean;
}

const RecurringEventModal = ({ isOpen, onClose, isEditSingleMeeting, onRadioChange, onSave }: Props) => (
  <Modal isCentered isOpen={isOpen} onClose={onClose}>
    <ModalOverlay />
    <ModalContent position="relative" maxH="204px" maxW={isMobileView() ? '300px' : '578px'}>
      <ModalHeader position="relative">
        <Flex alignItems="center">
          <Repeat boxSize="24px" color="#333333" mr="8px" />
          <TextHeader3 bold>Edit Recurring Event</TextHeader3>
        </Flex>
        <StyleCloseButton
          variant="filled"
          color="black"
          StartIcon={(props) => <Cross {...props} boxSize="20px" />}
          onClick={onClose}
        />
      </ModalHeader>
      <Divider opacity={1} color="#EBEFF3" />

      <ModalBody p="26px 30px">
        <Box>
          <Flex>
            <Radio
              onChange={() => {
                onRadioChange && onRadioChange(true);
              }}
              isChecked={isEditSingleMeeting}
              name="editSingleMeeting"
            >
              <TextBodyMedium ml="8px">Edit this meeting</TextBodyMedium>
            </Radio>
          </Flex>
          <Flex mt="16px">
            <Radio
              onChange={() => {
                onRadioChange && onRadioChange(false);
              }}
              isChecked={!isEditSingleMeeting}
              name="editAllMeetings"
            >
              <TextBodyMedium ml="8px">Edit this and all following meetings</TextBodyMedium>
            </Radio>
          </Flex>
        </Box>
      </ModalBody>
      <ModalFooter
        sx={{
          background: '#F5F7F9',
          borderTop: '1px solid #CED7DF',
          borderRadius: '0px 0px 8px 8px',
        }}
      >
        <Button
          sx={{
            '&>p': {
              marginLeft: 0,
            },
          }}
          mr="auto"
          variant="tertiary"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button onClick={onSave}>Save</Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);

export { RecurringEventModal };
